<script setup lang="ts">
import { computed, useId } from 'vue';
import { classNames } from '@/js/lib/bem';

export type SelectOption = {
  value: string
  label: string
};

const props = withDefaults(
  defineProps<{
    label?: string
    name: string
    modelValue?: string
    options: SelectOption[]
    placeholder?: string
    disabled?: boolean
    invalid?: boolean
    message?: string
    required?: boolean
  }>(),
  {
    modelValue: '',
    placeholder: 'Select',
    disabled: false,
    invalid: false,
    message: undefined,
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>();

const selectId = useId();

const cn = classNames('base-field');

const fieldClasses = computed(() =>
  cn(props.invalid ? { state: 'invalid' } : undefined),
);
</script>

<template>
  <div :class="fieldClasses" :data-message="message || undefined">
    <select
      :id="selectId"
      :name="name"
      :value="modelValue"
      :disabled="disabled"
      :required="required"
      @change="
        emit('update:modelValue', ($event.target as HTMLSelectElement).value)
      "
    >
      <option value="" disabled>
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <label :for="selectId" class="base-field__label">{{ label }}</label>
  </div>
</template>
